module.exports = __webpack_public_path__ + "static/media/iphone_12_pro_max_gold.099cd271.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_12_pro_max_gold.png
// module id = 2099
// module chunks = 0